export function createGlobalStore() {
    return {
        isNavOpen: false,

        toggleNav() {
            this.isNavOpen = !this.isNavOpen;
        }
    }
}